var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sidebar-layout", {
    attrs: { moduleCode: _vm.moduleCode },
    scopedSlots: _vm._u(
      [
        {
          key: "aside-main-menu",
          fn: function () {
            return [
              _c("gestao-menu", { attrs: { moduleCode: _vm.moduleCode } }),
            ]
          },
          proxy: true,
        },
        {
          key: "main",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass: "pt-3 px-md-4 pt-md-4 pb-0",
                  class: `${_vm.moduleCode}-page`,
                },
                [_vm._t("default")],
                2
              ),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }